<template>
    <div>
        <h1 class="newxgmsgtop"><span style="color:red">{{cKeyWord}}</span>的最新相关消息</h1>
        <ul class="newxgmsgcont">
            <li v-for="(item, index) in cNewestmsgList.slice(0,5)" :key="index">
                <i></i>
                <a :href="item.docpuburl" target="_blank" :title="item.title">{{item.title}}</a>
                <span>{{item.docpubtime.substring(0,10)}}</span>
            </li>
        </ul>
    </div>
</template>
<script>
export default ({
    name: "v-special-newestmsg",
    components: {},
    props:{
        cKeyWord: {
            default: "",
        },
        cNewestmsgList: {
            type: Array,
            default: function () {
                return [];
            },
        },
    },
    data(){
        return{
            
        }
    }
})
</script>

<style lang="less" scoped>
.newxgmsgtop{
    font-size: 18px;
    color: #000;
    font-weight:normal;
    margin-bottom: 0;
    margin-top: 0;
}
.newxgmsgcont{
    width: 791px;
    // padding-left: 30px;
    overflow: hidden;
    margin-top: 0;
    background: #fafafa;
    border: 1px solid #e1e1e1;
    padding:10px 15px;
    border-radius: 5px;
    margin-top: 10px;
    margin-bottom: 20px;

}
.newxgmsgcont li{
    line-height: 26px;
    position: relative;
    overflow: hidden;
}
.newxgmsgcont li i{
    width: 4px;
    height: 4px;
    display: block;
    position: absolute;
    top: 12px;
    left: 0px;
    background: #015293;
    border-radius: 100%;
} 
.newxgmsgcont li:hover a{
    color:#015293;
}
.newxgmsgcont a{
    font-size: 16px;
    color: #000;
    width: 86%;
    display: block;
    float: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 15px;
}
.newxgmsgcont span{
    font-size: 14px;
    float: right;
}
</style>